import {initialScheduleState, IScheduleState} from '@app/core/store/state/schedule.state';
import {EErrorActions, ErrorActions} from '@app/core/store/actions/error.actions';
import {EScheduleActions, ScheduleActions} from '@app/core/store/actions/schedule.actions';
import {ESickDaysActions, SickDaysActions} from '@app/core/store/actions/sick-days.actions';
import {ISickDay} from '@app/core/interfaces/sick-days.interface';
import {EShiftTemplatesActions, ShiftTemplatesActions} from '@app/core/store/actions/shift-templates.actions';

export const scheduleReducers = (
	state = initialScheduleState,
	action: ScheduleActions | ErrorActions | SickDaysActions | ShiftTemplatesActions,
): IScheduleState => {
	switch (action.type) {
		case EErrorActions.LoadError: {
			return {
				...state,
				isLoading: false,
				isCreatingUpdatingDeletingShift: false,
				isShiftsLoading: false,
				hasShiftChanges: false,
			};
		}
		case EScheduleActions.GetShifts: {
			return {
				...state,
				isShiftsLoading: true,
			};
		}
		case EScheduleActions.GetShiftsSuccess: {
			return {
				...state,
				shifts: action.shifts,
				isShiftsLoading: false,
			};
		}
		case EScheduleActions.GetUserShifts: {
			return {
				...state,
			};
		}
		case EScheduleActions.GetUserShiftsSuccess: {
			return {
				...state,
				userShifts: action.shifts,
			};
		}
		case EScheduleActions.SetSelectedDates: {
			return {
				...state,
				selectedDates: action.selectedDates,
			};
		}
		case EScheduleActions.SetViewType: {
			return {
				...state,
				viewType: action.viewType,
			};
		}
		case EScheduleActions.SetPeriodType: {
			return {
				...state,
				periodType: action.periodType,
			};
		}
		case EScheduleActions.SetSelectedStartWeek: {
			return {
				...state,
				selectedStartWeek: action.weekNumber,
				selectedYear: action.year,
			};
		}
		case EScheduleActions.GetGroupsSuccess: {
			return {
				...state,
				groups: action.groups,
			};
		}
		case EScheduleActions.GetUsersSuccess: {
			return {
				...state,
				users: action.users,
			};
		}
		case EScheduleActions.SetSelectedShift: {
			return {
				...state,
				selectedShift: action.shift,
			};
		}
		case EScheduleActions.PostShift: {
			return {
				...state,
				isCreatingUpdatingDeletingShift: true,
			};
		}
		case EScheduleActions.PostShiftSuccess: {
			return {
				...state,
				isCreatingUpdatingDeletingShift: false,
				shifts: state.shifts.concat([action.shift]),
				hasShiftChanges: true,
				lastShiftUpdated: action.shift,
			};
		}
		case EScheduleActions.DeleteShift: {
			return {
				...state,
				isCreatingUpdatingDeletingShift: true,
				lastShiftUpdating: action.shift,
			};
		}
		case EScheduleActions.DeleteShiftSuccess: {
			return {
				...state,
				isCreatingUpdatingDeletingShift: false,
				shifts: state.shifts.filter(s => s.id !== action.shift.id),
				hasShiftChanges: true,
				lastShiftUpdated: action.shift,
			};
		}
		case EScheduleActions.PatchShift: {
			return {
				...state,
				isCreatingUpdatingDeletingShift: true,
				lastShiftUpdating: state.shifts.find(s => s.id === action.id),
			};
		}
		case EScheduleActions.PatchShiftSuccess: {
			return {
				...state,
				isCreatingUpdatingDeletingShift: false,
				shifts: state.shifts.map(s => {
					if (s.id === action.originalShiftId) {
						return action.shift;
					}

					return s;
				}),
				hasShiftChanges: true,
				lastShiftUpdated: action.shift,
			};
		}
		case EScheduleActions.SetSelectedDate: {
			return {
				...state,
				selectedDate: action.selectedDate,
			};
		}
		case EScheduleActions.SetIsCopying: {
			return {
				...state,
				isCopying: action.isCopying,
			};
		}
		case EScheduleActions.SetDraggingShift: {
			return {
				...state,
				draggingShift: action.shift,
			};
		}
		case EScheduleActions.SetSelectedModel: {
			return {
				...state,
				selectedModel: action.model,
			};
		}
		case EScheduleActions.GetAvailabilitiesSuccess: {
			return {
				...state,
				availabilities: action.availabilities,
			};
		}
		case EScheduleActions.SetSortingType: {
			return {
				...state,
				sortingType: action.sortingType,
			};
		}
		case EScheduleActions.AddShiftToStock: {
			return {
				...state,
				isCreatingUpdatingDeletingShift: true,
			};
		}
		case EScheduleActions.AddShiftToStockSuccess: {
			return {
				...state,
				shifts: state.shifts.map(s => {
					if (s.id === action.shiftId) {
						s.public_shift_stock_id = action.publicShiftStockId;
					}

					return s;
				}),
				isCreatingUpdatingDeletingShift: false,
				hasShiftChanges: true,
			};
		}
		case EScheduleActions.RemoveShiftFromStock: {
			return {
				...state,
				isCreatingUpdatingDeletingShift: true,
			};
		}
		case EScheduleActions.RemoveShiftFromStockSuccess: {
			return {
				...state,
				shifts: state.shifts.map(s => {
					if (s.id === action.shiftId) {
						s.public_shift_stock_id = null;
					}

					return s;
				}),
				isCreatingUpdatingDeletingShift: false,
				hasShiftChanges: true,
			};
		}

		case EScheduleActions.AddShiftStockBid: {
			return {
				...state,
				isCreatingUpdatingDeletingShift: true,
			};
		}
		case EScheduleActions.AddShiftStockBidSuccess: {
			return {
				...state,
				shifts: state.shifts.map(s => {
					if (s.id === action.shiftId) {
						s.bid_on_shift = true;
					}

					return s;
				}),
				isCreatingUpdatingDeletingShift: false,
			};
		}
		case EScheduleActions.RemoveShiftStockBid: {
			return {
				...state,
				isCreatingUpdatingDeletingShift: true,
			};
		}
		case EScheduleActions.RemoveShiftStockBidSuccess: {
			return {
				...state,
				shifts: state.shifts.map(s => {
					if (s.id === action.shiftId) {
						s.bid_on_shift = false;
					}

					return s;
				}),
				isCreatingUpdatingDeletingShift: false,
			};
		}
		case EShiftTemplatesActions.InsertShiftTemplate: {
			return {
				...state,
				isShiftsLoading: true,
			};
		}
		case EShiftTemplatesActions.InsertShiftTemplateSuccess: {
			return {
				...state,
				isShiftsLoading: false,
			};
		}
		case EScheduleActions.GetShift: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EScheduleActions.SetUsersWhoBid: {
			return {
				...state,
				usersWhoBid: action.usersWhoBid,
			};
		}
		case EScheduleActions.SetAvailableUsers: {
			return {
				...state,
				availableUsers: action.availableUsers,
			};
		}
		case EScheduleActions.SetFetchedShift: {
			return {
				...state,
				fetchedShift: action.fetchedShift,
			};
		}
		case EScheduleActions.GetShiftSuccess: {
			return {
				...state,
				isLoading: false,
				fetchedShift: action.shift,
				availableUsers: action.availableUsers,
				usersWhoBid: action.usersWhoBid,
			};
		}
		case EScheduleActions.DeleteShiftsInInterval: {
			return {
				...state,
				isShiftsLoading: true,
			};
		}
		case EScheduleActions.DeleteShiftsInIntervalSuccess: {
			return {
				...state,
				shifts: [],
				hasShiftChanges: true,
				isShiftsLoading: false,
			};
		}
		case EScheduleActions.SetScrollLeft: {
			return {
				...state,
				scrollLeft: action.scrollLeft,
			};
		}
		case EScheduleActions.SetPrinting: {
			return {
				...state,
				printing: action.printing,
			};
		}
		case ESickDaysActions.PostSickDaySuccess: {
			const currentSelectedShift = state.selectedShift;
			if (currentSelectedShift?.id === action.sickDay.shift_id) {
				currentSelectedShift.sick_message_id = action.sickDay.id;
			}

			return {
				...state,
				shifts: state.shifts.map(s => s.id === action.sickDay.shift.id ? action.sickDay.shift : s),
				selectedShift: currentSelectedShift,
			};
		}
		case ESickDaysActions.ApproveSickDaySuccess: {
			return {
				...state,
				shifts: state.shifts.map(shift => shift.id === action.sickDay.shift.id ? action.sickDay.shift : shift),
				selectedShift: action.sickDay.shift,
			};
		}
		case ESickDaysActions.GetSickDaysSuccess: {
			const shiftIdsHashMap: { [shift_id: number]: ISickDay } = action.sickDays.reduce((result, sd) => {
				result[sd.shift.id] = sd;

				return result;
			}, {});
			const selectedShift = state.selectedShift;
			if (selectedShift && shiftIdsHashMap[state.selectedShift.id]) {
				selectedShift.sick_message_id = shiftIdsHashMap[state.selectedShift.id].id;
			}
			const fetchedShift = state.fetchedShift;
			if (fetchedShift && shiftIdsHashMap[state.fetchedShift.id]) {
				fetchedShift.sick_message_id = shiftIdsHashMap[state.fetchedShift.id].id;
			}

			return {
				...state,
				shifts: state.shifts.map(shift => {
					if (shiftIdsHashMap[shift.id]) {
						shift.sick_message_id = shiftIdsHashMap[shift.id].id;
					}

					return shift;
				}),
				selectedShift,
				fetchedShift,
			};
		}

		case EScheduleActions.SetReceivedDepartmentIdsCachingCalculation: {
			return {
				...state,
				departmentsIdsCalculated: action.shiftIds,
			};
		}

		case EScheduleActions.SetHasShiftChange: {
			return {
				...state,
				hasShiftChanges: action.hasChange,
			};
		}
		default:
			return state;
	}
};
